/**
 * Comportamenti scroll dell'header:
 * - is-compact: barra più piccola + sfondo traslucido dopo un po' di scroll
 *   (o sempre, sulle pagine senza hero);
 * - is-revealed: il CTA "Prenota" compare superato l'hero (subito se non c'è);
 * - data-theme: light/dark in base alla sezione sotto l'header.
 */
export function initHeader() {
	const header = document.getElementById( 'site-header' );
	if ( ! header ) {
		return;
	}

	const COMPACT_AT = 24;
	const cta  = header.querySelector( '.site-header__cta' );
	const hero = document.querySelector( '.hero' );

	let coverY = 0;
	const recalcCover = () => {
		coverY = hero ? Math.max( 0, hero.offsetHeight - header.offsetHeight - 40 ) : 0;
	};

	const apply = () => {
		const y = window.scrollY;

		header.classList.toggle( 'is-compact', ! hero || y > COMPACT_AT );

		if ( cta ) {
			const revealed = y >= coverY;
			cta.classList.toggle( 'is-revealed', revealed );
			cta.setAttribute( 'tabindex', revealed ? '0' : '-1' );
			cta.setAttribute( 'aria-hidden', revealed ? 'false' : 'true' );
		}

		// Tema dalla sezione che si trova sotto l'header.
		const el = document.elementFromPoint( window.innerWidth / 2, header.offsetHeight + 8 );
		const section = el ? el.closest( '[data-header-theme]' ) : null;
		const theme = section ? section.dataset.headerTheme : 'dark';
		if ( header.dataset.theme !== theme ) {
			header.dataset.theme = theme;
		}
	};

	let rafId = null;
	const onScroll = () => {
		if ( null === rafId ) {
			rafId = requestAnimationFrame( () => {
				rafId = null;
				apply();
			} );
		}
	};

	recalcCover();
	apply();
	window.addEventListener( 'scroll', onScroll, { passive: true } );
	window.addEventListener( 'resize', () => {
		recalcCover();
		apply();
	}, { passive: true } );
}
